import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AdminRoute = () => {
    const { isAdmin, isLoading } = useAuth();

    if (isLoading) {
        return <div>Загрузка...</div>; // ✅ Пока проверяем, админ ли пользователь, показываем лоадер
    }

    return isAdmin ? <Outlet /> : <Navigate to="/" replace />; // 🔥 Если не админ → редирект
};

export default AdminRoute;
